module.exports = __webpack_public_path__ + "assets/img/29_33.f208cd03.jpg";